import { render, staticRenderFns } from "./TagsWrapper.vue?vue&type=template&id=05b4e7b3&scoped=true&"
import script from "./TagsWrapper.vue?vue&type=script&lang=js&"
export * from "./TagsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TagsWrapper.vue?vue&type=style&index=0&id=05b4e7b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4e7b3",
  null
  
)

export default component.exports